import React, { type FunctionComponent } from 'react'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'

interface ProductsSearchErrorPageProps
  extends Omit<React.ComponentProps<typeof ErrorPage>, 'children'> {}

export const ProductsSearchErrorPage: FunctionComponent<ProductsSearchErrorPageProps> = props => {
  const messages = useDomainMessages({
    label: 'productsDomain.search.error',
  })

  return <ErrorPage {...props}>{messages.label}</ErrorPage>
}
